import { render } from "./FooterView.vue?vue&type=template&id=680d78bd&scoped=true&ts=true"
import script from "./FooterView.vue?vue&type=script&lang=ts"
export * from "./FooterView.vue?vue&type=script&lang=ts"

import "./FooterView.vue?vue&type=style&index=0&id=680d78bd&lang=scss&scoped=true"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680d78bd"]])

export default __exports__